import React, { ReactNode, useCallback } from "react";

import { SliderActions } from "@/common/Slider";
import Svg from "@/styles/utils/Svg";

import { Content, Navigator, Title, Wrapper } from "./styles";

export type HeaderProps = {
  visible: boolean;
  navigation?: { previous: boolean; next: boolean; isSlideChanged?: boolean };
  onNavigationClick?: (
    event: React.MouseEvent<HTMLElement>,
    direction: SliderActions
  ) => void;
  icons?: IIcons;
  children?: ReactNode;
};

const Header: React.FC<HeaderProps> = ({
  visible,
  navigation,
  children,
  icons,
  onNavigationClick,
}) => {
  const handleOnPrevious = useCallback(
    (e: React.MouseEvent<HTMLElement>): void => {
      if (navigation?.previous && onNavigationClick) {
        onNavigationClick(e, SliderActions.prev);
      }
    },
    [navigation, onNavigationClick]
  );

  const handleOnNext = useCallback(
    (e: React.MouseEvent<HTMLElement>): void => {
      if (navigation?.next && onNavigationClick) {
        onNavigationClick(e, SliderActions.next);
      }
    },
    [navigation, onNavigationClick]
  );

  return (
    <Wrapper data-qa="header">
      <Content>
        <Navigator onClick={handleOnPrevious}>
          {navigation?.previous && icons && (
            <Svg contents={icons.PageLeft} height={32} width={32} />
          )}
        </Navigator>
        <Title $show={visible}>{children}</Title>
        <Navigator onClick={handleOnNext}>
          {navigation?.next && icons && (
            <Svg contents={icons.PageRight} height={32} width={32} />
          )}
        </Navigator>
      </Content>
    </Wrapper>
  );
};

export default Header;
export { Header };
